import { supabase } from 'utils/supabaseClient';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL

export const tryFetchWithAuth = async (path, options = {}) => {
    try {
        const {
            data: { session }
        } = await supabase.auth.getSession();
        const accessToken = session?.access_token;

        if (!accessToken) {
            localStorage.setItem('postLoginRedirect', window.location.pathname);
            window.location.href = '/loginsignup';
            return {
                data: null,
                error: 'No access token. Redirected to login.',
                status: 401,
            };
        }

        const fetchUrl = `${API_BASE_URL}${path}`;
        console.log('[tryFetchWithAuth] Fetching URL:', fetchUrl, 'with options:', options);

        // Define default headers, allow options.headers to override, then add Auth
        const requestHeaders = {
             'Content-Type': 'application/json', // Default assumption for outgoing data
             'Accept': 'application/json, text/plain, */*', // Indicate we can accept various types
             ...(options.headers || {}), // Allow user-provided headers to override defaults
             Authorization: `Bearer ${accessToken}`, // Ensure Authorization is always added last
         };

        // Remove Content-Type if body is not present or not typical JSON data (optional refinement)
        if (!options.body || !(typeof options.body === 'string' || options.body instanceof FormData === false)) {
             // If no body, or body is FormData, Content-Type is often set automatically or not needed
             // Keeping it simple for now, but be aware if sending FormData etc.
             // delete requestHeaders['Content-Type']; // Example if needed
        }


        const response = await fetch(fetchUrl, {
            ...options,
            headers: requestHeaders,
        });

        // --- MODIFICATION START ---

        let data;
        let errorText = null; // Initialize errorText

        if (!response.ok) {
            // Handle error responses (4xx, 5xx)
            // Try to get text body for error details
            try {
                errorText = await response.text();
                console.error(`[tryFetchWithAuth] API Error ${response.status}:`, errorText);
            } catch (e) {
                // If reading text fails for some reason
                 console.error(`[tryFetchWithAuth] API Error ${response.status}, failed to read error body:`, e);
                 errorText = `API request failed with status ${response.status}, unable to read error body.`;
            }
            return {
                data: null,
                error: errorText || `API request failed with status ${response.status}`, // Use read text or fallback
                status: response.status,
            };
        }

        // Handle successful responses (2xx)
        const contentType = response.headers.get('content-type');
        console.log('[tryFetchWithAuth] Response Content-Type:', contentType);

        if (contentType && contentType.includes('application/json')) {
            // Response is JSON
            data = await response.json(); // Parse as JSON
             console.log('[tryFetchWithAuth] Received JSON data');
        } else if (contentType && contentType.includes('text/')) {
            // Response is Text (e.g., text/csv, text/plain)
            data = await response.text(); // Get raw text
            console.log('[tryFetchWithAuth] Received Text data');
        } else {
            // Fallback for other types or missing Content-Type on success
            // Could be blob, etc. Defaulting to text might be safest for now.
            console.warn('[tryFetchWithAuth] Unknown Content-Type on success, attempting to read as text.');
            data = await response.text();
        }

        // --- MODIFICATION END ---

        return {
            data, // Contains parsed JSON or raw text based on Content-Type
            error: null,
            status: response.status,
        };

    } catch (error) { // Catch network errors or other unexpected issues
        console.error('[tryFetchWithAuth] Network or other error:', error);
        // Avoid using alert in a utility function if possible
        // alert('Something went wrong. Please try again.');
        return {
            data: null,
            error: error.message || 'Unexpected network error',
            // Use a distinct status or null for network errors vs API errors
            status: 0, // Or null, or keep 500 if preferred convention
        };
    }
}